export default {"src":"/_next/static/media/contentads.a8114cf1.svg","height":204,"width":387,"blurWidth":0,"blurHeight":0};